module.exports = __webpack_public_path__ + "static/media/referral-count-background.55cbd137.png";